import {NOTIFICATION_LIST} from '@constants/internal-route.constant'
import {IAppRoutes} from '@interface/common.interface'
import {guard} from './route-guard'

export const NotificationRoutes: IAppRoutes = {
  link: NOTIFICATION_LIST,
  childrens: [
    {
      link: NOTIFICATION_LIST,
      element: guard(() => import('@modules/notification/NotificationList'), [NOTIFICATION_LIST]),
    },
  ],
}
